import type { ReactNode } from 'react'
import { NavLink } from 'react-router-dom'

import { serverRoot } from '../observability/routing'
import { useConsoleView } from '../observability/state'

export function AppShell({ children }: { children: ReactNode }) {
  const { snapshot, connectionStatus } = useConsoleView()
  const root = serverRoot(snapshot.instance.publicBaseUrl)
  const navigation = [
    { to: root, label: 'Overview', end: true },
    { to: `${root}/agents`, label: 'Agents', end: false },
    { to: `${root}/tasks`, label: 'Tasks', end: false },
    { to: `${root}/context`, label: 'Context', end: false },
  ]

  return (
    <div className="app-shell">
      <header className="topbar">
        <div>
          <p className="eyebrow">Terminal MCP</p>
          <h1>Console</h1>
        </div>
        <div className="topbar-meta">
          <span className={`status status-${connectionStatus}`}>{connectionStatus}</span>
          <span className="environment-badge">{snapshot.instance.publicBaseUrl}</span>
        </div>
      </header>
      <div className="shell-grid">
        <nav className="sidebar" aria-label="Console navigation">
          {navigation.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <main className="content">{children}</main>
      </div>
    </div>
  )
}
